module.exports = __webpack_public_path__ + "static/img/IMG_20160310_223412.5f2c07ab.jpg";